<template>
  <div class="not-data-wallet">
    <img src="../imgs/not-data.png" alt="">
    <div class="text">
      请到“财务管理-我的钱包”中查看钱包状态
    </div>
    <el-button type="primary" size="small" @click="toWallet">
      去查看
    </el-button>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();

function toWallet() {
  router.push({ name: 'MyWallet' });
}
</script>

<style lang="scss" scoped src="../style/my-wallet.scss" />
